import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { StandardResponse } from '@shared/interfaces/generic-response';
import { IPermissionDashboard } from '@feature/settings/interfaces';
import { ApiEndpoints } from '@shared/common/apiPoint';
import { map, take, throwError, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Dashboard } from 'src/app/shared/interfaces/dashboard.interface';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private readonly _http = inject(HttpClient);

  getAllDashboards(body = {}) {
    return this._http
      .post<
        StandardResponse<{ permissionDashboards: IPermissionDashboard[] }>
      >(ApiEndpoints.BIDashboards.get_all_dashboards, body)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error in getting the grid data: ', error);
          return throwError(() => new Error(error.message));
        }),
        map(response => {
          if (response.status === 200 && response.data) {
            return response.data.permissionDashboards;
          }
          return [];
        }),
      );
  }

  getDashboardsByAccountId(accountId: number): Observable<Dashboard[]> {
    return this._http
      .get<{
        data: Dashboard[];
      }>(`${ApiEndpoints.BIGroups.getDashboardsByAccountId}/${accountId}`)
      .pipe(
        map(response => response?.data || []),
        catchError((error: HttpErrorResponse) => {
          console.error('Error loading dashboards by accountId:', error);
          return of([]);
        }),
      );
  }

  toggleDashboardStatus(dashboardId: number) {
    return this._http
      .put<
        StandardResponse<any>
      >(`${ApiEndpoints.BIDashboards.update_dashboard_status}/${dashboardId}`, {})
      .pipe(take(1));
  }

  addDashboard(body: any) {
    return this._http
      .post<
        StandardResponse<any>
      >(`${ApiEndpoints.BIDashboards.add_dashboard}`, body)
      .pipe(take(1));
  }

  editDashboard(body: any) {
    return this._http
      .put<
        StandardResponse<any>
      >(`${ApiEndpoints.BIDashboards.edit_dashboard}?id=${body.dashboardId}`, body)
      .pipe(take(1));
  }

  deleteDashboard(dashboardId: number) {
    return this._http
      .delete<
        StandardResponse<any>
      >(`${ApiEndpoints.BIDashboards.delete_dashboard}?id=${dashboardId}`)
      .pipe(take(1));
  }
}
